import { BotConnectionEvent } from '../models/connectionsEvent';

export function mapOnlineData(raw: any): BotConnectionEvent | null {
console.log("rawbot",raw)

try{
  const mappedResponse =  {
    bots: Array.isArray(raw?.bots)
      ? raw.bots.map((b: any) => ({
          id: typeof b?.id === "string" ? b.id : "",
          name: typeof b?.name === "string" ? b.name : "unknown",
          mainPhotoUrl: typeof b?.mainPhotoUrl === "string" ? b.mainPhotoUrl : "",
          cockpits: Array.isArray(b?.cockpits)
            ? b.cockpits.map((c: any) => ({
                _id: typeof c?.id === "number" ? c.id : "unknown",
                deviceId: typeof c?.deviceId === "number" ? c.deviceId : -1,
                name: typeof c?.name === "string" ? c.name : "unknown",
                status: typeof c?.status === "string" ? c.status : "unknown",
                player: {
                  id: typeof c?.player?.id === "string" ? c.player.id : null,
                  name: typeof c?.player?.name === "string" ? c.player.name : null,
                },
              }))
            : [],
            session: {
              OwnerType: b?.session?.OwnerType,
              id: b?.session?.id,
              ownerId: b.session.ownerId
            }
        }
      ))
      : [],

    users: Array.isArray(raw?.users)
      ? raw.users.map((u: any) => ({
          id: typeof u?.id === "string" ? u.id : "unknown",
          userName:
            typeof u?.userName === "string"
              ? u.userName
              : typeof u?.email === "string"
              ? u.email
              : "unknown",
          socketId: typeof u?.socketId === "string" ? u.socketId : "unknown",
        }))
      : [],

    admins: Array.isArray(raw?.admins)
      ? raw.admins.map((a: any) => ({
          id: typeof a?.id === "string" ? a.id : "unknown",
          userName:
            typeof a?.userName === "string"
              ? a.userName
              : typeof a?.email === "string"
              ? a.email
              : "unknown",
          socketId: typeof a?.socketId === "string" ? a.socketId : "unknown",
        }))
      : [],
  };
  return mappedResponse
}
catch (e) {
  console.log('mapped response failed', e)
  return null
}
}